export const INPUT_MAX_LENGTH_DEFAULT = 255;
export const INPUT_MAX_LENGTH_SHEET_NUMBER = 20;
export const INPUT_MAX_LENGTH_COMMENTS_NOTES = 3000;
